// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { openExitDialog } from 'actions/exitDialog';

import applicationActions from 'common/support/applicationActions';
import device from 'common/support/device';

import Focusable from 'components/focus/Focusable';

import { toggleClosedCaptioning } from 'actions/closedCaptioning';
import { showFullScreenPlayer } from 'actions/hero';

const AppActionsHandler = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const heroData = useSelector(state => state.kitchenSink?.data?.hero?.data);

  const onAction = action => {
    if (action === applicationActions.back) {
      history.goBack();

      try {
        if (history.entries[history.index]?.pathname === '/hero') {
          // started from hero carousel player and pressed onto an auth discovery row video
          // pressing back from login screen (/shortcode) brings you back to hero player
          const searchParams = new URLSearchParams(
            history.entries[history.index]?.search,
          );
          const videoId = searchParams.get('video');
          if (
            heroData?.find(videoItem => videoItem?.id === videoId) !== undefined
          ) {
            // play hero video if it still exists in the hero carousel
            dispatch(showFullScreenPlayer(videoId));
          } else {
            // if video no longer exists in hero carousel, go back to home
            history.goBack();
          }
        }
      } catch {
        // no-op
      }
      return true;
    }

    if (action === applicationActions.exit) {
      dispatch(openExitDialog());
      return true;
    }

    if (action === applicationActions.captions && device.useCCAppAction) {
      dispatch(toggleClosedCaptioning());
      return true;
    }

    return false;
  };

  return (
    <Focusable
      onAction={onAction}
      className={classNames('w-100', 'h-100')}
      disableFocusOnHover
      render={() => children}
    />
  );
};

AppActionsHandler.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppActionsHandler;
